import React from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/modules/userSlice";
import { findJoineeForm } from "./joineeStatus";

var OBJECT_ID_RE = /^[a-f\d]{24}$/i;

/** Super Admin lands on Manage HR, HR on Manage New Joinee. */
export function adminHomePath(user) {
  if (user && user.isSuperAdmin) return "/AdminUsers";
  return "/AdminEmployees";
}

export function employeeRecordPath(id, formId) {
  var path = "/AdminEmployeeRecord/" + encodeURIComponent(id);
  return formId && findJoineeForm(formId) ? path + "?form=" + formId : path;
}

/** Replaces the old dashboard; runs inside PrivateAdmin. */
export function AdminHomeRedirect() {
  var { user } = useSelector(selectUser);
  return <Navigate to={adminHomePath(user)} replace />;
}

/** HR-only screens (joinee list + review); the API enforces the same rule. */
export function RequireHrAdmin() {
  var { user } = useSelector(selectUser);
  if (!user || !user.isAdmin) {
    return <Navigate to={adminHomePath(user)} replace />;
  }
  return <Outlet />;
}

export function RequireSuperAdmin() {
  var { user } = useSelector(selectUser);
  if (!user || !user.isSuperAdmin) {
    return <Navigate to={adminHomePath(user)} replace />;
  }
  return <Outlet />;
}

/**
 * Old /AdminSDF/:id style links open the review page with that form selected.
 * Anything that is not a Mongo id goes back to the list instead of being echoed into a URL.
 */
export function LegacyFormRedirect(props) {
  var params = useParams();
  var id = params.id || "";
  if (!OBJECT_ID_RE.test(id)) {
    return <Navigate to="/AdminEmployees" replace />;
  }
  return <Navigate to={employeeRecordPath(id, props.formId)} replace />;
}
